<template lang="pug">
    .orders
        h1.orders__title Заказы
        a(href='#').btn Получить ссылку на оплату
        .orders__top
            form.orders-find
                .orders-find__group
                    label.form__label Найти в заказах
                    input(type='text').form__input
                button.btn.btn--dark-grey Найти
            a(href='#').orders__export Экспорт
                svgicon(name='export')
        .orders__filters.filter
            template(v-if="windowWidth > 991")
                .filter-item
                    v-select(
                        :options=['По убыванию', 'По возрастанию']
                        :searchable="false"
                        :clearable="false"
                        :placeholder="'ID'"
                    ).form__select.form__select--filter.form__select--filter-mini
                .filter-item
                    v-select(
                        :options=['+7 (929) 650-30-29', '+7 (929) 623-30-29', '+7 (929) 123-22-44']
                        :searchable="true"
                        :clearable="false"
                        :placeholder="'Телефон'"
                    ).form__select.form__select--filter
                        template(v-slot:no-options) Извините, нет подходящих вариантов.
                .filter-item
                    v-select(
                        :options=['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '15+']
                        :searchable="false"
                        :clearable="false"
                        :placeholder="'Кол-во билетов'"
                    ).form__select.form__select--filter
                .filter-item
                    v-select(
                        :options=['5000', '10000', '20000']
                        :searchable="false"
                        :clearable="false"
                        :placeholder="'Сумма'"
                    ).form__select.form__select--filter
                .filter-item
                    v-select(
                        :options=['В режиме обмена билетов', 'Принят ожидается оплата', 'Полный возврат', 'Отменен']
                        :searchable="false"
                        :clearable="false"
                        :placeholder="'Статус'"
                    ).form__select.form__select--filter
                .filter-item.filter-item--calendar
                    date-picker(
                        v-model="dateOrder"
                        format="DD.MM.YYYY"
                        placeholder='Дата заказа')
                .filter-item.filter-item--calendar
                    date-picker(
                        v-model="datePay"
                        format="DD.MM.YYYY"
                        placeholder='Дата оплаты')
            template(v-else)
                .filter-item
                    v-select(
                        :options=['По убыванию', 'По возрастанию']
                        :searchable="false"
                        :clearable="false"
                        :placeholder="'ID'"
                    ).form__select.form__select--filter.form__select--filter-mini
                a(href="#" @click.prevent="filterMob = true").filter-mob
                    svgicon(name='filter')
                .filter-mob-hidden(v-show="filterMob")
                    a(href="#" @click.prevent="filterMob = false").filter-mob__back
                        svgicon(name="arrow" dir="right")
                        span Фильтры
                    .filter-item
                        v-select(
                            :options=['+7 (929) 650-30-29', '+7 (929) 623-30-29', '+7 (929) 123-22-44']
                            :searchable="true"
                            :clearable="false"
                            :placeholder="'Телефон'"
                        ).form__select.form__select--filter
                            template(v-slot:no-options) Извините, нет подходящих вариантов.
                    .filter-item
                        v-select(
                            :options=['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '15+']
                            :searchable="false"
                            :clearable="false"
                            :placeholder="'Кол-во билетов'"
                        ).form__select.form__select--filter
                    .filter-item
                        v-select(
                            :options=['5000', '10000', '20000']
                            :searchable="false"
                            :clearable="false"
                            :placeholder="'Сумма'"
                        ).form__select.form__select--filter
                    .filter-item
                        v-select(
                            :options=['В режиме обмена билетов', 'Принят ожидается оплата', 'Полный возврат', 'Отменен']
                            :searchable="false"
                            :clearable="false"
                            :placeholder="'Статус'"
                        ).form__select.form__select--filter
                    .filter-item.filter-item--calendar
                        date-picker(
                            v-model="dateOrder"
                            format="DD.MM.YYYY"
                            placeholder='Дата заказа')
                    .filter-item.filter-item--calendar
                        date-picker(
                            v-model="datePay"
                            format="DD.MM.YYYY"
                            placeholder='Дата оплаты')

        .orders__content
            template(v-if="visibleItems > 0")
                p.no-result Нет подходящих вариантов
            .orders-table(v-else)
                .orders-table__title
                    .orders-table__th.at-col-1 ID
                    .orders-table__th.at-col-2 Статус
                    .orders-table__th.at-col-3 Имя
                    .orders-table__th.at-col-4 E-mail
                    .orders-table__th.at-col-5 Телефон
                    .orders-table__th.at-col-6 Сумма
                    .orders-table__th.at-col-7 Билетов
                    .orders-table__th.at-col-8 Дата заказа
                    .orders-table__th.at-col-9 Дата оплаты
                    .orders-table__th.at-col-10

                .orders-table__content
                    template(v-if="windowWidth > 992")
                        .orders-table__item.item-order(
                            v-for='order in orders'
                            :key="order.id"
                            v-if="order.visible"
                        )
                            .item-order__item.at-col-1 {{ order.id }}
                            .item-order__item.at-col-2 {{ order.status }}
                            .item-order__item.at-col-3 {{ order.name }}
                            .item-order__item.at-col-4 {{ order.email }}
                            .item-order__item.at-col-5 {{ order.phone }}
                            .item-order__item.at-col-6 {{ order.summ }}
                            .item-order__item.at-col-7 {{ order.tickets }}
                            .item-order__item.at-col-8 {{ order.dateOrder }}
                            .item-order__item.at-col-9 {{ order.datePay }}
                            .item-order__item.at-col-10
                                template(v-if="order.pdf")
                                    a(href='#').item-order__report
                                        svgicon(name='pdf')
                                a(href='#').item-order__edit
                                    svgicon(name='edit')

                    template(v-else)
                        .orders-table__item.item-order(
                            v-for='order in orders'
                            :key="order.id"
                            v-if="order.visible",
                        )
                            .item-order__item.at-col-1
                                span ID
                                |{{ order.id }}
                            .item-order__item.at-col-2
                                span Статус
                                |{{ order.status }}
                            .item-order__item.at-col-3
                                span Имя
                                |{{ order.name }}
                            .item-order__item.at-col-4
                                span E-mail
                                |{{ order.email }}
                            .item-order__item.at-col-5
                                span Телефон
                                |{{ order.phone }}
                            .item-order__item.at-col-6
                                span Сумма
                                |{{ order.summ }}
                            .item-order__item.at-col-7
                                span Билетов
                                |{{ order.tickets }}
                            .item-order__item.at-col-8
                                span Дата заказа
                                |{{ order.dateOrder }}
                            .item-order__item.at-col-9
                                span Дата оплаты
                                |{{ order.datePay }}
                            .item-order__item.at-col-10
                                template(v-if="order.pdf")
                                    a(href='#').item-order__report
                                        svgicon(name='pdf')
                                a(href='#').item-order__edit
                                    svgicon(name='edit')

        .orders__total.total-order
            .total-order__col
                .total-order__item Выбрано заказов:
                    span 1140
                .total-order__item Продаж квоты:
                    span 2394000 руб.
            .total-order__col
                .total-order__item Фактически продано на
                    span 2417000 руб.
                .total-order__item Возвратов 11 заказов на
                    span 21300 руб.
            .total-order__col
                .total-order__item Комиссия за возвраты
                    span 1700 руб.

        .orders__bottom
            .order__pagination.pagination
                a(href='#').pagination__link.active 1
                a(href='#').pagination__link 2
                a(href='#').pagination__link 3
                .pagination__span ...
                a(href='#').pagination__link 9
                a(href='#').pagination__link.pagination__next
                    svgicon(name='arrow' dir='left')
            .orders__pages-setting.pages-setting
                .pages-setting__pages 1—5 из 200
                .pages-setting__bypage.bypage
                    .bypage__title На странице
                    v-select(
                        :options=['5', '10', '15', '20', '50', 'Все',]
                        :searchable="false"
                        :clearable="false"
                        :placeholder="'5'"
                    ).bypage__select

</template>

<style lang='scss' scoped>
    .orders-table__th,
    .item-order__item{
        flex-shrink: 0;
        flex-grow: 1;
        padding-right: 10px;
        line-height: 22px;
    }
    .at-col-1{
        width: 35px;
        flex-grow: 0;
    }
    .at-col-2{
        width: 80px;
    }
    .at-col-3{
        width: 80px;
    }
    .at-col-4{
        width: 70px;
        word-break: break-all;
        flex-grow: 3;
    }
    .at-col-5{
        width: 125px;
    }
    .at-col-6{
        width: 50px;
    }
    .at-col-7{
        width: 65px;
    }
    .at-col-8{
        width: 80px;
    }
    .at-col-9{
        width: 90px;
    }
    .at-col-10{
        width: 65px;
        flex-grow: 0;
    }
</style>
<style lang='scss'>
.orders{
    &__title{
        color: #161616;
        font-size: 22px;
        font-weight: 700;
        line-height: 25px;
        margin-top: 0;
        margin-bottom: 25px;
    }
    &-find{
        display: flex;
        align-items: flex-end;
        &__group{
            margin-right: 20px;
        }
        .form__input{
            width: 565px;
        }
    }
    &__top{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    &__export{
        color: #161616;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        margin-bottom: 7px;
        .svg-icon{
            width: 18px;
            height: 22px;
            margin-left: 10px;
            color: #008cff;
        }
        &:hover{
            color: #008cff;
        }
    }
    &__filters{
        flex-wrap: wrap;
        margin: 0 -10px;
        .filter-item{
            flex-grow: 1;
            display: flex;
            margin: 0 10px 10px;
            .form__select{
                flex-grow: 1;
            }
            .form__select--filter-mini{
                width: 80px;
            }
            .mx-datepicker{
                width: 150px;
                flex-grow: 1;
            }
        }
    }
    &__bottom{
        margin-top: 30px;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

}
.total-order{
    display: flex;
    background-color: #e7f1f8;
    padding: 15px 20px;
    margin-top: 20px;
    &__col{
        padding-right: 20px;
        max-width: 40%;
        flex-grow: 1;
    }
    &__item{
        color: #161616;
        font-size: 15px;
        margin-top: 10px;
        margin-bottom: 10px;
        span{
            font-weight: 600;
            margin-left: 5px;
        }
    }
}
.pagination{
    display: flex;
    &__link{
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #e4e4e4;
        background-color: #ffffff;
        border-radius: 50%;
        text-decoration: none;
        margin-right: 10px;
        color: #161616;
        font-size: 14px;
        &:hover{
            border-color: #c1e5ff;
            background-color: #c1e5ff;
        }
        &.active{
            border-color: #e7f1f8;
            background-color: #e7f1f8;
        }
    }
    &__span{
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #e4e4e4;
        background-color: #ffffff;
        border-radius: 50%;
        text-decoration: none;
        margin-right: 10px;
        color: #161616;
        font-size: 14px;
    }
    &__next{
        .svg-icon{
            width: 11px;
            height: 11px;
        }
    }
}
.pages-setting{
    display: flex;
    align-items: center;
    &__pages{
        color: #161616;
        font-size: 14px;
        margin-right: 30px;
    }
}
.bypage{
    display: flex;
    align-items: center;
    &__title{
        color: #9398a2;
        font-size: 14px;
        margin-right: 15px;
    }
    &__select{
        width: 70px;
        height: 37px;
        line-height: 37px;
        display: inline-flex;
    }
    .vs__dropdown-menu{
        min-width: 70px;
    }
}
.orders-table{
    width: 100%;
    &__title{
        display: flex;
        margin-bottom: 10px;
        padding: 0px 15px;
    }
    &__th{
        color: #9398a2;
        font-size: 14px;
    }
    &__content{
        box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
    }
}
.item-order{
    display: flex;
    background-color: #ffffff;
    padding: 15px 15px;
    color: #161616;
    font-size: 14px;
    position: relative;
    &:before{
        content: '';
        display: block;
        position: absolute;
        top: -1px;
        left: 25px;
        width: calc(100% - 50px);
        height: 1px;
        background: #e4e4e4;
    }
    &:hover{
        background-color: #e7f1f8;
    }
    &:first-child:before{
        display: none;
    }
    &__status{
        color: #008cff;
        font-weight: 600;
    }
    &__report{
        margin-top: 5px;
        margin-bottom: 5px;
        margin-right: 10px;
        display: inline-block;
        .svg-icon{
            fill: #008cff;
            width: 25px;
            height: 25px;
        }
        &:hover{
            .svg-icon{
                fill: #026ac0;
            }
        }
    }
    &__edit{
        margin-top: 5px;
        margin-bottom: 5px;
        display: inline-block;
        .svg-icon{
            fill: #008cff;
            width: 22px;
            height: 22px;
        }
        &:hover{
            .svg-icon{
                fill: #026ac0;
            }
        }
    }
    &__link{
        display: block;
        color: #008cff;
        font-size: 14px;
        font-weight: 600;
        text-decoration: none;
        margin-bottom: 5px;
        &:hover{
            text-decoration: underline;
        }
    }
    &__item{
        span{
            font-size: 12px;
            display: block;
            margin-bottom: 8px;
            color: #a2a2a2;
        }
    }
}

@media (max-width: 991px) {
    .orders__filters .filter-item{
        flex-grow: 0;
    }
    .orders-table{
        margin-top: 20px;
    }
    .orders-table__title{
        display: none;
    }
    .orders__filters{
        margin: 0;
    }
    .orders__filters .filter-item{
        margin: 0;
    }

    .item-order{
        flex-wrap: wrap;
        & &__item{
            width: calc(33.3% - 10px);
            padding-right: 0;
            margin: 0 5px 15px;
            flex-grow: 0;
        }
    }
    .orders-find .form__input {
        width: 400px;
    }
}
@media (max-width: 767px) {
    .total-order{
        flex-wrap: wrap;
    }
    .total-order__col{
        width: calc(50% - 20px);
        max-width: 50%;
    }
    .orders__bottom{
        flex-direction: column;
    }
    .pagination{
        margin-bottom: 20px;
    }
    .orders-find .form__input {
        width: 190px;
    }
}
@media (max-width: 479px) {
    .item-order{
        & &__item{
            width: calc(50% - 10px);
            padding-right: 0;
            margin: 0 5px 15px;
            flex-grow: 0;
        }
    }
    .orders__top{
        flex-direction: column;
        align-items: flex-start;
    }
    .orders-find{
        width: 100%;
        margin-bottom: 10px;
    }
    .orders-find__group{
        flex-grow: 1;
    }
    .orders-find .form__input {
        width: 100%;
        box-sizing: border-box;
    }
    .total-order__col{
        width: 100%;
        max-width: 100%;
        padding-right: 0;
    }
}
</style>

<script>
export default {
  name: 'Orders',
  data: function() {
    return {
      windowWidth: null,
      filterMob: false,
      dateOrder: null,
      datePay: null,
      orders: [
        {
          id: 5134,
          status: 'В режиме обмена билетов',
          name: 'Ксения Петрова',
          email: 'zuliubov@mail.ru',
          phone: '+7 (929) 650-30-29',
          summ: 117000,
          tickets: 2,
          dateOrder: '07.03.2017 14:48:22',
          datePay: '07.03.2017 14:51:19',
          pdf: true,
          visible: true,
        }, {
          id: 513,
          status: 'Принят ожидается оплата',
          name: 'Константин Федосеев',
          email: 'anastasiy.hromova2016@yandex.ru',
          phone: '+7 (929) 650-30-29',
          summ: 117000,
          tickets: 2,
          dateOrder: '07.03.2017 14:48:22',
          datePay: '07.03.2017 14:51:19',
          pdf: true,
          visible: true,
        }, {
          id: 5221,
          status: 'Полный возврат',
          name: 'Константин Федосеев',
          email: 'anastasiy.hromova2016@yandex.ru',
          phone: '+7 (929) 650-30-29',
          summ: 117000,
          tickets: 2,
          dateOrder: '07.03.2017 14:48:22',
          datePay: '07.03.2017 14:51:19',
          pdf: true,
          visible: true,
        }, {
          id: 1332,
          status: 'Отменен',
          name: 'Ксения Петрова',
          email: 'Bagrat-10@mail.ru',
          phone: '+7 (929) 650-30-29',
          summ: 117000,
          tickets: 2,
          dateOrder: '07.03.2017 14:48:22',
          datePay: '07.03.2017 14:51:19',
          pdf: true,
          visible: true,
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  computed: {
    visibleItems(){
      let visibleItems = 0;
      this.orders.forEach(item => {
        if(item.visible === false) {
          visibleItems += 1;
        }
      });
      return this.orders.length === visibleItems;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>